import type { TStopPropagationInterceptor } from 'shared/ui/PropagationInterceptor/types';

export const updateEvent = (e: TStopPropagationInterceptor) => {
  e.skipEvent = true;
};

export const isSkipEvent = (e: TStopPropagationInterceptor) => {
  return e.skipEvent;
};
